import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "messages" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_animated = _resolveComponent("message-animated")!
  const _component_message_input_choices = _resolveComponent("message-input-choices")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_message_animated, {
      strings: _ctx.messages,
      onStringtyped: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checkMessageStatus($event)))
    }, null, 8, ["strings"]),
    (_ctx.messageDone)
      ? (_openBlock(), _createBlock(_component_message_input_choices, {
          key: 0,
          choices: _ctx.choices,
          onChosen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkChoice($event)))
        }, null, 8, ["choices"]))
      : _createCommentVNode("", true)
  ]))
}